import 'core-js';

import currencyConverterApp from '../components/currencyConverterApp.vue';
import OfficeMap from '../components/OfficeMap.vue';
import LoanApplicationForm from '../components/loanapplication/LoanApplicationForm.vue';
// import '../_formieForms';
import * as Vue from 'vue/dist/vue.esm-bundler';
import { createApp } from 'vue/dist/vue.esm-bundler';
import { setupCalendar } from 'v-calendar';
import { translations, translate } from '../_translations';

var currencyConverters = document.querySelectorAll('.currencyConverter');

if (currencyConverters) {
  currencyConverters.forEach((currencyConverter) => {
    const appHeight = currencyConverter.offsetHeight;
    // currencyConverter.style.height = `${appHeight}px`;

    const region = currencyConverter.getAttribute('data-region');
    const lang = currencyConverter.getAttribute('data-lang');
    let cardCurrency = 'EUR';
    let bankFee = '1.95'; // Default bank fee used for Finland

    if (region === 'SE') {
      cardCurrency = 'SEK';
      bankFee = '1.65';
    }

    const app = createApp(currencyConverterApp, {
      region,
      lang,
      cardCurrency,
      bankFee
    });

    app.use(setupCalendar, {})

    app.mount(currencyConverter);
  });
}

const offices = document.getElementById('offices');

if (offices) {
  const app = createApp(OfficeMap, {
    apiKey: offices.dataset.apiKey,
    offices: JSON.parse(offices.dataset.officeList),
    countries: JSON.parse(offices.dataset.countryList),
    strings: JSON.parse(offices.dataset.translations),
  });

  app.mount(offices);
}


const loanApplication = document.getElementById('loan-application-form');
if (loanApplication) {
  const app = createApp(LoanApplicationForm, {
    options: JSON.parse(loanApplication.dataset.options),
    translations: JSON.parse(loanApplication.dataset.translations),
    links: JSON.parse(loanApplication.dataset.links),
  });

  // Make translation function available globally
  app.config.globalProperties.$t = (string, params = {}) => translate(string, params);

  app.mount(loanApplication);
}